'use client';

import { useEffect, useState } from 'react';

/**
 * true quando o viewport esta abaixo do desktop de 2 colunas (<=1023px) -
 * mesmo corte dos @media das telas de auth. matchMedia com listener de
 * resize/rotacao. SSR retorna false (desktop) e corrige no mount - mesmo
 * trade-off do isSuperAdminContext do /login (1 frame de flash, aceitavel).
 */
export function useIsMobileViewport(query = '(max-width: 1023px)'): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const update = () => setIsMobile(mql.matches);
    update();
    mql.addEventListener('change', update);
    return () => mql.removeEventListener('change', update);
  }, [query]);

  return isMobile;
}
